'use client';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import HeroSection from './components/HeroSection';
import HomepageVideoSection from './components/HomepageVideoSection';
import StatsSection from './components/StatsSection';
import ProductPreviewSection from './components/ProductPreviewSection';
import ApitherapyTeaserSection from './components/ApitherapyTeaserSection';
import BrandStorySection from './components/BrandStorySection';
import CebinovSection from './components/CebinovSection';
import FinalCTASection from './components/FinalCTASection';
import { useLanguage } from '@/contexts/LanguageContext';

export default function Homepage() {
  const { currentLang } = useLanguage();

  return (
    <>
      <Header currentLang={currentLang} />
      <main>
        <HeroSection currentLang={currentLang} />
        <HomepageVideoSection />
        <BrandStorySection currentLang={currentLang} />
        <CebinovSection currentLang={currentLang} />
        <ProductPreviewSection currentLang={currentLang} />
        <StatsSection currentLang={currentLang} />
        <ApitherapyTeaserSection currentLang={currentLang} />
        <FinalCTASection currentLang={currentLang} />
      </main>
      <Footer currentLang={currentLang} />
    </>
  );
}
